import React, { useEffect } from "react";
import { inject, observer } from 'mobx-react';
import MaterialTable from "material-table";
import ReportsMenu from '../ReportsMenu';
import { TableOptions, qarFindingsColumns, localization } from '../Constants';
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner'
import '../Reporting.css';

const QARFindings = inject('RootStore')(observer(({ RootStore }) => {

  useEffect((() => {
    RootStore.reportingStore.getAllFindingsForAllAccounts(RootStore.qarStore.currentComplianceReviewId);
    RootStore.reportingStore.setRenderSpinner(true)
  }), [RootStore.reportingStore]);

  return (
    <div className="row">
      {RootStore.reportingStore.renderSpinner && <LoadingSpinner text='Loading report' />}
      <ReportsMenu />
      <div className="col-sm-9" id="report-table">
        <div>
          {<MaterialTable
            title="QAR Findings for all Accounts"
            data={RootStore.reportingStore.qarFindings}
            columns={qarFindingsColumns}
            options={TableOptions}
            localization={localization}
          />}
        </div>
      </div>
    </div>
  )
}));

export default QARFindings;